import {
  Box,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import MuiTypographyMandatory from '../../../Components/Custom/MuiTypographyMandatory';

function PaymentMethodSection({ selected, setSelected, options }) {
  return (
    <Box>
      <MuiTypographyMandatory variant="h3" required={true} label={"Payment Method"} sx={{fontWeight: 700}}></MuiTypographyMandatory>

      <Paper sx={{ mt: 1, p: 2, borderRadius: 2, width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
        <RadioGroup
          row
          value={selected}
          onChange={e => setSelected(e.target.value)}
          sx={{ flexWrap: 'wrap', gap: 0.5, rowGap: 0.5 }}
        >
          {options.map(opt => (
            <FormControlLabel
              key={opt}
              value={opt}
              control={<Radio />}
              label={opt}
            />
          ))}
        </RadioGroup>
      </Paper>
    </Box>
  );
}

export default PaymentMethodSection;